import { createAction, props } from '@ngrx/store';
import { LookBook, LookBookItem } from '@epicuro-next/models/engagement';

export const setListToSelected = createAction(
  '[ShopTheLook] Set selected list',
  props<{ lookBookItem: LookBookItem }>(),
);

export const setSelectedLists = createAction(
  '[ShopTheLook] Set selected lists',
  props<{ lists: LookBookItem[] }>(),
);

export const removeFromSelectedLists = createAction(
  '[ShopTheLook] Remove from selected lists',
  props<{ productListId: string }>(),
);

export const loadLookBookEditSuccess = createAction(
  '[ShopTheLook] Load Look Book To Edit Success',
  props<{ lookBook: LookBook }>(),
);

export const loadLookBookEdit = createAction(
  '[ShopTheLook] Load Look Book To Edit',
  props<{ lookBookId?: string }>(),
);

export const loadLookBookEditError = createAction(
  '[ShopTheLook] Load Look Book To Edit Error',
  props<{ error: string }>(),
);

export const reorderShopTheLookSelectedItems = createAction(
  '[ShopTheLook] Reorder Look Book items',
  props<{ prevIndex: number; currentIndex: number }>(),
);

export const clearShopTheLookEditState = createAction(
  '[ShopTheLook] Clear Look Book To Edit',
);

export const editLookBook = createAction(
  '[ShopTheLook] Edit lookBook',
  props<{ lookBook: LookBook }>(),
);

export const editLookBookSuccess = createAction(
  '[ShopTheLook] Edit lookBook Success',
  props<{ lookBook: LookBook }>(),
);

export const editLookBookNotify = createAction(
  '[ShopTheLook] Edit LookBook Notify',
  props<{ message: string }>(),
);

export const editLookBookError = createAction(
  '[ShopTheLook] Edit LookBook Error',
  props<{ error: string }>(),
);

export const deleteLookBook = createAction(
  '[ShopTheLook] Delete Look Book',
  props<{ lookBookId: string }>(),
);

export const deleteLookBookSuccess = createAction(
  '[ShopTheLook] Delete Look Book Success',
  props<{
    lookBookId: string;
    lookbookNewsFeedId?: string;
    lookbookTitle?: string;
  }>(),
);

export const deleteLookBookNotify = createAction(
  '[ShopTheLook] Delete Look Book Notify',
  props<{ lookbookTitle?: string }>(),
);

export const deleteLookBookError = createAction(
  '[ShopTheLook] Delete Look Book Error',
  props<{ error: string }>(),
);
